import React, { memo } from 'react';
import cn from 'classnames';

import { TCustomIcons } from 'src/libs/ui-kit/custom-icon';

import styles from './styles.module.scss';
import { Badge } from 'react-bootstrap';
import { IOrderCost, PaymentSystem } from '../../../../../orders/pages/order-view/interfaces/payments';

export const OrderCostCell = memo<IOrderCost>((props) => (
  <td>
    <div className={styles.tableOptions}>
      <div className={cn(styles.optionName, 'font-regular-base')}>Подытог</div>
      <div className="font-regular-base">
        {props.subTotalPrice != null &&
          (props.subTotalPrice / 100).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}
      </div>

      <div className={cn(styles.optionName, 'font-regular-base')}>Скидка</div>
      <div className="font-regular-base">
        {props.discount != null && (props.discount / 100).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}
      </div>

      <div className={cn(styles.optionName, 'font-regular-base')}>Бонусы</div>
      <div className="font-regular-base">{props.bonusesUsed || 0}</div>

      <div className={cn(styles.optionName, 'font-regular-base')}>Итог</div>
      <div className="font-regular-base">
        {props.totalPrice != null &&
          (props.totalPrice / 100).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}
      </div>

      {/* <div className={cn(styles.optionName, 'font-regular-base')}>Оплата</div>
      <div className="font-regular-base">
        {props.paymentType === PaymentType.Cash && 'Наличные'}
        {props.paymentType === PaymentType.Card && props.paymentSystem != null && (
          <CustomIcon className="mr-1" name={PAYMENT_SYSTEM_ICON_MAP[props.paymentSystem]} />
        )}{' '}
        {props.cardNumber}
      </div> */}

      <div className={cn(styles.optionName, 'font-regular-base')}>Статус</div>
      <div className="font-regular-base">
        {props.isPaid ? <Badge variant="success">Оплачен</Badge> : <Badge variant="warning">Не оплачен</Badge>}
      </div>
    </div>
  </td>
));

const PAYMENT_SYSTEM_ICON_MAP: Record<PaymentSystem, TCustomIcons> = {
  [PaymentSystem.AmericanExpress]: 'american-express',
  [PaymentSystem.DinersClub]: 'diners-club',
  [PaymentSystem.Discover]: 'discover',
  [PaymentSystem.Jcb]: 'jcb',
  [PaymentSystem.Maestro]: 'maestro',
  [PaymentSystem.MasterCard]: 'mastercard',
  [PaymentSystem.Mir]: 'mir',
  [PaymentSystem.Pro100]: 'pro100',
  [PaymentSystem.UnionPay]: 'unionpay',
  [PaymentSystem.Visa]: 'visa',
};
